export const CLEAN_LTE = 'CLEAN_LTE';